if (!customElements.get('seal-coast-progress')) {
  customElements.define('seal-coast-progress', class extends HTMLElement {
    connectedCallback() {
      if (this.requested) return;
      this.requested = true;
      fetch('https://wmi-group.at/api/trash-removed/', { cache: 'no-store' })
        .then(response => {
          if (!response.ok) throw new Error('Counter unavailable');
          return response.text();
        })
        .then(raw => {
          let value;
          try {
            const data = JSON.parse(raw);
            value = typeof data === 'object' && data !== null ? data.total_m2 ?? data.total ?? data.value : data;
          } catch { value = raw; }
          const total = typeof value === 'number' ? value : Number(String(value).replace(/[.,\s]/g, ''));
          if (!Number.isSafeInteger(total) || total < 100) return;
          const target = this.querySelector('[data-coast-total]');
          if (target) target.textContent = new Intl.NumberFormat(document.documentElement.lang || undefined).format(total);
        })
        .catch(() => { /* Keep the last verified merchant fallback. */ });
    }
  });
}
